export default {
  exposPersonnelles: [
    {
      marker: '2005',
      texts: [
        '- will es sein, aux bords et sur le fond -  Galerie Dominique Lang,  Dudelange (L)'
      ]
    },
    {
      marker: '1997',
      texts: [
        '- slopes and ponds - a guide to the botanic area - Galerie Biever-Risch (L)'
      ]
    },
    {
      marker: '1996',
      texts: [
        '- Peinture de Montagne et d’Eau -   Atelier, ancienne laiterie à Weiler-la Tour (L)',
        'Ambassade du Luxembourg, Den Haag (NL)',
        'European Investment Bank (L)'
      ]
    },
    {
      marker: '1993',
      texts: ['- canons d’autel -  Galerie Beaumont (L)']
    },
    {
      marker: '1991',
      texts: ['- zone côtière -   Galerie Beaumont (L)']
    },
    {
      marker: '1989',
      texts: [
        '- navigations ... et je deviens le fleuve -   Galerie Beaumont (L)'
      ]
    },
    {
      marker: '1987',
      texts: [
        '- cargo de nuit - oder - vom Wandern auf gekrümmten Pfaden - Galerie Beaumont (L)'
      ]
    },
    {
      marker: '1985',
      texts: ['- foisonnement des possibles -   Galerie Beaumont (L)']
    },
    {
      marker: '1980/83',
      texts: ['Galerie La Cité (L)']
    },
    {
      marker: '1979/80',
      texts: ['Galerie Charles Munchen (L)']
    },
    {
      marker: '1978',
      texts: ['Galerie 30 à Warnach/Fauvillers (B)']
    }
  ],
  autreDates: [
    {
      marker: '2003',
      texts: ['Lauréate du Prix Grand-Duc Adolphe (L)']
    },
    {
      marker: '1998',
      texts: ['Intervention en zone piétonne de Luxembourg-Ville - under your feet, immense immensité - comme une poudre d’or sur les pas de la nuit -']
    },
    {
      marker: '1993',
      texts: ['par P&T Luxembourg, émission d’un timbre postal d’après la peinture - so close - collectionMNHA (L)']
    },
    {
      marker: '1989',
      texts: ['en représentation du Grand-Duché de Luxembourg à EUROARTE, Guimaraès, Portugal']
    },
    {
      marker: '1987',
      texts: ['Voyage en Australie']
    },
    {
      marker: '1986',
      texts: ['Mention du Jury, Festival International de la Peinture à Cagnes-sur-Mer (F)']
    },
    {
      marker: '1985',
      texts: ['IIe Prix de la Biennale (L)']
    },
    {
      marker: '1981',
      texts: ['en résidence à la Cité Internationale des Arts à Paris', 'Premier Prix de la Peinture, Xe Biennale des Jeunes (L)']
    },
    {
      marker: '1979',
      texts: ['Prix de la Critique, IXe Biennale des Jeunes (L)']
    },
    {
      marker: '1991 - 2016',
      texts: ['Restauratrice en Archéologie au MNHA Luxembourg']
    }
  ],
  exposCollective: [
    {
      marker: '2014',
      texts: ['- Quatre décennies de création artistique, Acquisitions de la Ville de Luxembourg, au Cercle Cité Luxembourg']
    },
    {
      marker: '2013',
      texts: ['- Florilège - Les années 1980 dans la collection des P&T - au Cercle Cité, Ratskeller, Luxembourg', '- Les lauréats du Prix Grand-Duc Adolphe - de 1946 à nos jours - Centre Culturel de Rencontre Abbaye de Neumünster']
    },
    {
      marker: '2003',
      texts: ['- <i>de Manessier à Wim Delvoye</i> - <i></i>la Collection de S.A.R. la Grande-Duchesse Joséphine-Charlotte</i> - au M.N.H.A. (L)']
    },
    {
      marker: '2002',
      texts: ['- <i>Hommage aux Artistes Luxembourgeois</i> - BCEE Luxembourg (L)']
    },
    {
      marker: '1999',
      texts: ['- <i>Quatre artistes, Cinq ans après</i> - Banque Générale Kirchberg (L)']
    },
    {
      marker: '1998',
      texts: ['- <i>Montrez-moi qui désirer</i> - (installations), S.T. art events, Luxembourg']
    },
    {
      marker: '1996',
      texts: ['- <i>les extrêmes se touchent</i> - l’Art Contemporain au Luxembourg - Centre de Presse International Nieuwspoort, Den Haag (NL)']
    },
    {
      marker: '1995',
      texts: ['sélectionnée au Prix d’Art Robert Schuman (L)']
    },
    {
      marker: '1994',
      texts: ['- Imago Lussemburgi - Palais Wallenstein, Prague']
    },
    {
      marker: '1991 - 1993',
      texts: ['- Peintres Luxembourgeois d’Aujourd’hui - exposition itinérante en France (F)']
    },
    {
      marker: '1991',
      texts: ['Millesgarden Museum, Stockholm (S)', '- Similitudes et Différences - Saar-Lor-Lux, Saarlandmuseum Saarbrücken (D)', '- Grands et Jeunes d’Aujourd’hui - Grand Palais, Paris (F)', '- Communautés Européennes - Luxembourg et Bruxelles (L/B)']
    },
    {
      marker: '1990',
      texts: ['Lineart, Gent (B)']
    },
    {
      marker: '1989',
      texts: ['- <i>entracte-promenade</i> - Echternach Festival (L)', '- <i>Tischgespräche</i> - (installation), Galerie Beaumont (L)', '- <i>et dans le haut pavillon…</i> - installation, en représentation du Luxembourg - EUROARTE, Encontro Europeu de Arte à Guimaraès (P)', '- <i>viens sous ma tente</i> - VANILLA - (installation), Cercle Municipal (L)']
    },
    {
      marker: '1988',
      texts: ['Quinquenale d’Art Moderne à Esch-sur-Alzette (L)']
    },
    {
      marker: '1987',
      texts: ['- <i>Combiné Luxembourgeois</i> - Centre Culturel de Berchem, Anvers (B)']
    },
    {
      marker: '1986',
      texts: ['Biennale d’Art Contemporain, Nancy (F)', ' - <i>Quanash</i> - in situ, Musée d’Art Moderne, Parc de la Boverie, Liège (B)', 'Festival International de la Peinture, Cagnes-sur-Mer (F)', '- <i>Jeunes Artistes Luxembourgeois</i> - Banque UCL (L)', 'sélectionnée au Prix Europe de Peinture de la Ville d’Oostende (B)', '- <i>das Tier im Bild von Heute</i> - Galerie Beaumont (L)']
    },
    {
      marker: '1985',
      texts: ['exposition - <i>Europe</i> - à la Sorbonne, Paris', '- <i>Papiers</i> - Galerie La Cité (L)']
    },
    {
      marker: '1983',
      texts: ['- Festival de l’Insolite - Grand Théâtre de Verviers (B)']
    },
    {
      marker: '1982',
      texts: ['- <i>Mises en Boîtes</i> - Maison de la Culture, Namur (B)', '- <i>Installations/Musique</i> - Galerie La Cité (L)', '- <i>Trente artistes luxembourgeois</i> - Villa Vauban (L)']
    },
    {
      marker: '1981',
      texts: ['- <i>petits formats</i> - exposition durant résidence, Cité Internationale des Arts à Paris']
    },
    {
      marker: '1979',
      texts: ['participation au Prix International - Art Actuel, Knokke-Heist (B)', '- <i>Confrontations</i> - Galerie Charles Munchen (L)']
    },
    {
      marker: '1976',
      texts: ['exposition-concours IIIe Biennale Internationale des Jeunes Peintres, Maison des Jeunes et de la Culture, Metz (F)']
    }
  ],
  catalogues: [
    {
      marker: '2014',
      texts: ['in: Quatre décennies de création artistique, Acquisitions de la Ville de Luxembourg des années 1970 à 2010']
    },
    {
      marker: '2013',
      texts: ['in : - <i>Florilège</i> - Les années 1980 dans la collection des P&T (L)', 'in : - <i>Prix Grand-Duc Adolphe</i> - de 1946 à nos jours - co-éd. CAL et mécénArt -éd. Saint-Paul']
    },
    {
      marker: '2009',
      texts: ['in : - <i>Contemporary Art in Luxembourg since 1970</i> - Enrico LUNGHI, Casino Luxembourg']
    },
    {
      marker: '2003',
      texts: ['in : - <i>de Manessier à Wim Delvvoye</i> - la Collection de S.A.R. la Grande-Duchesse Joséphine-Charlotte de Luxembourg, catalogue MNHA Luxembourg']
    },
    {
      marker: '2001',
      texts: ['in : - <i>Signatures, Artistes Plasticiens au Luxembourg</i> - Lambert HERR']
    },
    {
      marker: '1997',
      texts: ['in : - <i>slopes and ponds</i> - éd. Galerie Biever-Risch/S. Roef, auteurs: KAYSER/ROEF - Photodesign  CLEMENT']
    },
    {
      marker: '1996',
      texts: ['in : - <i>Les extrêmes se touchent</i> - L’art Contemporain au Luxembourg - Luxembourg/La Haye', 'in : catalogue - <i>Art Contemporain Luxembourgeois</i> - Collection de la BCEE']
    },
    {
      marker: '1995',
      texts: ['in : - <i>Artistes Luxembourgeois d’Aujourd’hui</i> -  Elisabeth VERMAST et Marc THEIS', ' in : catalogue Prix d’Art Robert Schuman']
    },
    {
      marker: '1991',
      texts: ['- <i>Hymne an die Farbe</i> -  Portrait (Magazine Carrière), auteur: Elisabeth VERMAST', 'in : - <i>Gravures luxembourgeoises</i> - Bibliothèque Nationale, Luxembourg']
    },
    {
      marker: '1989',
      texts: ['- <i>navigations... et je deviens le fleuve</i> - Galerie Beaumont, texte auteur : Lucien KAYSER', 'in : catalogue - Euro Arte - Portugal']
    },
    {
      marker: '1986',
      texts: ['in : - <i>B.A.C. Magazine</i> - Nancy, texte Hervé BIZE', 'in : - <i>Art actuel 3</i> - Musée d’Art Moderne, Liège']
    },
    {
      marker: '1985',
      texts: ['- <i>foisonnement des possibles</i> - Galerie Beaumont, texte auteur : Lucien KAYSER']
    },
    {
      marker: '1982',
      texts: ['in : - <i>Mises en boîtes</i> - Maison de la Culture, Namur']
    }
  ],
  collections: [
    {
      marker: ' ',
      texts: [
        'Collection de S.A.R. la Grande-Duchesse Joséphine-Charlotte de Luxembourg',
        'Collections particulières',
        'Ville de Dudelange',
        'Collections de l’Etat',
        'Gottardo Bank',
        'Union de Banques Suisses',
        'First Republic National Bank of New York',
        'Banque Dexia-BIL Luxembourg',
        'Banque Générale du Luxembourg',
        'Banque et Caisse d’Epargne de l’Etat',
        'Deutsche Bank',
        'Banque de Luxembourg',
        'Musée National d’Histoire et d’Art',
        'Bâtiments Publics Luxembourg',
        'Ville de Luxembourg',
        'Bibliothèque Nationale Luxembourg',
        'Postes & Télécommunications Luxembourg',
        'Cité Internationale des Arts, Paris',
        'C.L.T. (RTL) Luxembourg'
      ]
    }
  ]
}
